import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { AppState } from './types';
import { RootState } from '../types';

const state: AppState = {
  isLoading: true,
  blockedUI: false,
  redirectUrl: null,
  signedOut: false,
  createWallet: false,
  menuOpen: false,
};

const mutations: MutationTree<AppState> = {
  SET_LOADING(state: AppState, loadingState:Boolean) {
    state.isLoading = loadingState;
  },
  
  SET_BLOCK_UI(state: AppState) {
    state.blockedUI = true;
  },

  TOGGLE_MENU(state: AppState) {
    state.menuOpen = !state.menuOpen;
  },

  SET_REDIRECT_URL(state: AppState, redirectUrl: String) {
    state.redirectUrl = redirectUrl;
  },

  SET_SIGNED_OUT(state: AppState, signedOut:boolean) {
    state.signedOut = signedOut;
  },

  SET_CREATE_WALLET(state: AppState, createWallet:boolean) {
    state.createWallet = createWallet;
  },
};

const getters: GetterTree<AppState, RootState> = {
  isLoading: (state: AppState) => state.isLoading,
  isBlockedUI: (state: AppState) => state.blockedUI,
  redirectUrl: (state: AppState) => state.redirectUrl,
  signedOut: (state: AppState) => state.signedOut,
  createWallet: (state: AppState) => state.createWallet,
  menuOpen: (state: AppState) => state.menuOpen,
};

const actions: ActionTree<AppState, RootState> = {

  startLoader({ commit }: { commit: Function}) {
    commit('SET_LOADING', true);
  },

  stopLoader({ commit }: { commit: Function }) {
    commit('SET_LOADING', false);
  },

  blockUI({ commit }: { commit: Function, }) {
    commit('SET_BLOCK_UI', true);
  },

  unblockUI({ commit }: { commit: Function, }) {
    commit('SET_BLOCK_UI', false);
  },

  setRedirectUrl({ commit }: { commit: Function, }, redirectUrl: String) {
    commit('SET_REDIRECT_URL', redirectUrl);
  },

  signedOut({ commit }: { commit: Function, }) {
    commit('SET_SIGNED_OUT', true);
  },

  createWallet({ commit }: { commit: Function, }) {
    commit('SET_CREATE_WALLET', true);
  },

  toggleMenu({ commit }: { commit: Function, }) {
    commit('TOGGLE_MENU');
  },
};

export const appState: Module<AppState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
